import { ProjectVersion, CacheBustVersionParam } from "abweb/generated/version/GeneratedState";
export class VersionUtils {
  constructor() {}
  static get version() {
    return ProjectVersion;
  }
  static cacheBustUrl(url) {
    return url + (url.indexOf("?") < 0 ? "?" : "&") + CacheBustVersionParam;
  }
}
//# sourceMappingURL=VersionUtils.js.map
